import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect, useRef } from "react";

const RequireIssuedAccess = ({ children }: { children: React.ReactNode }) => {
  const { loading, canAccessIssuedInvoices } = useAuth();
  const { toast } = useToast();
  const warned = useRef(false);

  useEffect(() => {
    if (!loading && !canAccessIssuedInvoices && !warned.current) {
      warned.current = true;
      toast({
        title: "Sin acceso a Facturas emitidas",
        description: "Pide al administrador que te habilite esta sección.",
        variant: "destructive",
      });
    }
  }, [loading, canAccessIssuedInvoices, toast]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Cargando…</p>
      </div>
    );
  }

  if (!canAccessIssuedInvoices) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
};

export default RequireIssuedAccess;
